import * as React from 'react';
import {
  FlexLayout, GridLayout,
} from '../../../../../components';
import { Global, TemplateProps } from '../../../../../constants';
import { Collect } from '../Collect';
import { CollectTabBalGridHeader } from '../headers/CollectTabBalGridHeader';

/**
 * 화면 > 탭 > 발주내역
 * @window w_tb_e601w_sulchi_02
 * @category 설치수금현황
 */
export const CollectTabBalTemplate: React.FC<TemplateProps<Collect>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <GridLayout
      header={CollectTabBalGridHeader(scope)}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.dataBal}
    elGrid="dataBal"
    />
  </FlexLayout>
);
